import React, {useEffect, useState} from 'react';
import './ReceiveCustomerInstallments.scss';
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../Loader";
import CustomerInstallmentsTable from "./CustomerInstallmentsTable";
import CustomerInstallmentsDetail from "./CustomerInstallmentsDetail";

const ReceiveCustomerInstallments = () => {

  const [initialData, setInitialData] = useState([])
  const [isLoad, setIsLoad] = useState(false);
  const [step, setStep] = useState(1);
  const [detailData, setDetailData] = useState({
    tableRow: {},
    data: []
  })

  const getInsuranceData = async () => {
    const response = await _axios.get(prefixUrl() + `/insurance/?request=submittedInsuranceTable`)
    if (response.data.status) {
      setInitialData(response.data.data)
      setIsLoad(true)
    } else {
      toast.error(response.data.message)
    }
  }

  useEffect(() => {
    void getInsuranceData()
  }, []);

  return (
    <>
      {isLoad ?
        <section className={"main-receive-customer"}>
          {step === 1 ?
            <CustomerInstallmentsTable data={initialData} setStep={setStep} setDetailData={setDetailData}/> :
            <CustomerInstallmentsDetail detailData={detailData} setStep={setStep} setDetailData={setDetailData}/>
          }
        </section> : <Loader/>}
    </>
  );
};

export default ReceiveCustomerInstallments;